import {combineReducers} from "redux";

import {IUserPreferencesStore, userPreferencesReducer} from "./user_preferences_reducer";
import {IUserRecommendationsStateStore, userRecommendationsStateReducer} from "./user_recommendation_state_reducer";

export interface IUserStore {
    preferences?: IUserPreferencesStore;
    recommendationsState: IUserRecommendationsStateStore;
}

export const userReducer = combineReducers({
    preferences: userPreferencesReducer,
    recommendationsState: userRecommendationsStateReducer
});
import {combineReducers} from "redux";

import {IUserPreferencesStore, userPreferencesReducer} from "./user_preferences_reducer";
import {IUserRecommendationsStateStore, userRecommendationsStateReducer} from "./user_recommendation_state_reducer";

export interface IUserStore {
    preferences?: IUserPreferencesStore;
    recommendationsState: IUserRecommendationsStateStore;
}

export const userReducer = combineReducers({
    preferences: userPreferencesReducer,
    recommendationsState: userRecommendationsStateReducer
});
